//  window.addEventListener("change", myFunction);

//       function myFunction() {
        
//         alert('hello');
//         $('.drawer--right')
        
//       }



$(function() {
    $(".clear-cart").on("click", function(c) {
          $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            success: function() {
                location.reload()
            },
            dataType: "json"
        })
    })
    
//     $('#prev').on('click',function(){
//       alert('click');
//       $(".Slider-img").addClass("padding_slider");
//     })
    
    $( ".Slider-img #prev" ).on( "click", function() {
      console.log('ghgj');
    });
  
    

    
});

